module.exports = __webpack_public_path__ + "img/bodycheck5.e8fc57b0.png";